import { Avatar, Button, Divider, ListItemIcon, ListItemText, Menu, MenuItem, Typography } from '@mui/material';
import { Auth } from 'aws-amplify';
import FeatherIcon from 'feather-icons-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useThemeMode } from '../../components/theme';
import { HEADER_MENU_OPTIONS, THEME_MODES } from '../../helpers/constant';
import DEFAULT_AVATAR from "../../pages/images/default-avatar.jpg";

function ProfileMenuComponent({ user, userFullName }) {
    const navigate = useNavigate();
    const { colours, FONT } = useThemeMode();
    const [profileMenuElement, setProfileMenuElement] = React.useState(null);
    const profileMenuOpen = Boolean(profileMenuElement);

    return (
        <React.Fragment>
            <Button
                id="basic-button"
                aria-controls={profileMenuOpen ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={profileMenuOpen ? "true" : undefined}
                onClick={(e) => setProfileMenuElement(e.currentTarget)}
                variant="text"
                color='inherit'
                size="small"
                focusRipple={false}
                sx={{
                    minWidth: "inherit",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 1,
                    padding: .5,
                    textAlign: "left",
                }}
            >
                <Avatar alt={userFullName || user.attributes.email} src={DEFAULT_AVATAR} sx={{ width: 34, height: 34 }} />
                <Typography component="div" flexDirection="column" sx={{ display: { xs: "none", md: "flex" } }}>
                    <Typography component="div" fontSize={FONT.SIZE_13} sx={{ display: "inline-flex", alignItems: "center", gap: 1 }}>{userFullName || user.attributes.email} <Typography component="span" sx={{ display: "inline-flex" }}><FeatherIcon size={16} icon={profileMenuOpen ? "chevron-up" : "chevron-down"} /></Typography></Typography>
                    <Typography component="div" fontSize={FONT.SIZE_12} sx={(theme) => ({ color: theme.palette.mode === THEME_MODES.LIGHT ? colours.purple100 : colours.grayDark })}>Super Admin</Typography>
                </Typography>
            </Button>
            <Menu
                id="basic-menu"
                anchorEl={profileMenuElement}
                open={profileMenuOpen}
                onClose={() => setProfileMenuElement(null)}
                MenuListProps={{
                    "aria-labelledby": "basic-button",
                    sx: {
                        maxWidth: '100%'
                    }
                }}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                sx={{ marginTop: 1 }}
            >
                <MenuItem sx={{ cursor: 'default' }}>
                    <ListItemText
                        primary={userFullName ? userFullName : null}
                        secondary={user.attributes.email}
                        sx={{ whiteSpace: "normal", wordBreak: "break-word" }}
                    />
                </MenuItem>
                <Divider />
                {HEADER_MENU_OPTIONS.map(menu => (
                    <MenuItem
                        key={menu.name}
                        onClick={() => {
                            if (menu.signOut) {
                                Auth.signOut();
                            } else {
                                navigate(menu.to);
                            }
                            setProfileMenuElement(null);
                        }}
                    >
                        <ListItemIcon sx={{ color: colours.black }}>
                            <FeatherIcon size={20} icon={menu.icon} />
                        </ListItemIcon>
                        <ListItemText>{menu.name}</ListItemText>
                    </MenuItem>
                ))}
            </Menu>
        </React.Fragment>
    )
}

export default ProfileMenuComponent;